/* eslint-disable */
import React, { useContext, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
// import DateInputPicker from 'modules/common/components/DateInputPicker';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import {
  EXTENSION_NAMES,
  RELATIONSHIPS,
  VALID_IDS,
  WHAT_TO_PRINT,
  YES_OR_NO,
} from 'modules/civil-registry/constant';
import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createSelect,
  createInputDate,
  createTelephoneNumber,
  createInputMobileNumber,
  createSelectAddress,
  createInputMask,
  updateMarriageCertificate,
  showTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  getTransactionList,
  filter,
  getPurposeList,
  purposeList,
  createSelectCountry
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      mailing_address_region_code: _.get(formData, 'region_code') || '',
      mailing_address_province_code: _.get(formData, 'province_code') || '',
      mailing_address_municipality_code:
        _.get(formData, 'municipality_code') || '',
      mailing_address_barangay_code: _.get(formData, 'barangay_code') || '',
      mailing_address_street: _.get(formData, 'street') || '',
    };

    // form data
    // args.first_name = args.first_name.toUpperCase();
    // args.last_name = args.last_name.toUpperCase();

    updateMarriageCertificate(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
      getTransactionList(filter);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  useEffect(() => {
    getPurposeList();
  }, []);

  const purposeOptions = useMemo(() => {
    if (!purposeList) return [];
    return _.map(purposeList, (item) => ({
      value: item.attributes.code,
      label: item.attributes.name,
    }));
  }, [purposeList]);

  const isCountryCodeRequired = useMemo(() => {
    if (!formData.purpose_code || _.isEmpty(purposeList)) return false;
    const purposeInfo = purposeList.find(
      (purpose) => purpose.attributes.code === formData.purpose_code
    );
    return Boolean(_.get(purposeInfo, 'attributes.with_country_code'));
  }, [formData.purpose_code, purposeList]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <p className="col-12 font-weight-bold">
            {' '}
            Owner&apos;s Personal Information{' '}
          </p>
          <p className="col-12">Name of the Man/Husband</p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'husband_first_name', label: 'First Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'husband_middle_name', label: 'Middle Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'husband_last_name', label: 'Last Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'husband_extension_name',
                label: 'Extension Name',
              },
              EXTENSION_NAMES
            )}
          </div>

          <p className="col-12">Maiden Name of the Lady/Wife</p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'wife_first_name', label: 'First Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'wife_middle_name', label: 'Middle Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              { key: 'wife_last_name', label: 'Last Name:' },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'wife_extension_name',
                label: 'Extension Name',
              },
              EXTENSION_NAMES
            )}
          </div>

          <p className="col-12 font-weight-bold mt-3">Marriage Information</p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputDate({
              required: true,
              key: 'date_marriage',
              label: 'Date of Marriage',
            })}
          </div>
          {/* <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress(
              {
                key: 'place_marriage_region_code',
                label: 'Region:',
                isReadOnly: true,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress(
              {
                key: 'place_marriage_province_code',
                label: 'Province:',
                isReadOnly: true,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress(
              {
                key: 'place_marriage_municipality_code',
                label: 'City/Municipality:',
                isReadOnly: true,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress(
              {
                key: 'place_marriage_barangay_code',
                label: 'Barangay:',
                isReadOnly: true,
              },
              {},
              'form-control-uppercase'
            )}
          </div> */}

          <p className="col-12 font-weight-bold mt-3">
            Requestor&apos;s Information
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'requestors_first_name',
                label: 'First Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'requestors_middle_name',
                label: 'Middle Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                required: true,
                key: 'requestors_last_name',
                label: 'Last Name:',
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                key: 'requestors_extension_name',
                label: `Extension Name`,
              },
              EXTENSION_NAMES
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'relationship_to_the_owner',
                label: 'Relationship to the owner:',
              },
              RELATIONSHIPS.sort((a, b) => a.label.localeCompare(b.label))
            )}
          </div>

          <p className="col-12 font-weight-bold mt-3">Mailing Address</p>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('region', {
              required: true,
              key: 'region_code',
              label: `Region`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('province', {
              required: true,
              key: 'province_code',
              label: `Province`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('municipality', {
              required: true,
              key: 'municipality_code',
              label: `City/Municipality`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelectAddress('barangay', {
              required: true,
              key: 'barangay_code',
              label: `Barangay`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInput(
              {
                key: 'street',
                label: `Unit/Room No./Floor, Building Name, House No., Street Name`,
              },
              {},
              'form-control-uppercase'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMask(
              {
                key: 'mailing_zip_code',
                label: `Zip Code`,
              },
              '9999'
            )}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createTelephoneNumber({
              key: 'telephone_number',
              label: `Telephone No.`,
            })}
          </div>
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMobileNumber({
              key: 'mobile_number',
              label: `Mobile No.`,
            })}
          </div>

          <p className="col-12 font-weight-bold mt-3">
            Transactional Information
          </p>
          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'is_registered_late',
                label: `Registered Late? (if Yes)`,
              },
              YES_OR_NO
            )}
          </div>
          {(_.get(formData, 'is_registered_late') === '1' || _.get(formData, 'is_registered_late') === 1) ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createInputDate({
                required: true,
                key: 'registered_when',
                label: 'Registered when?',
              })}
            </div>
          ) : (
            <></>
          )}
          <div className="col-sm-12 col-md-6 form-group">
            {createInputMask(
              {
                required: true,
                key: 'number_of_copies',
                label: `No. of Copies`,
              },
              '999'
            )}
          </div>

          <div className="col-sm-12 col-md-6 form-group">
            {createSelect(
              {
                required: true,
                key: 'purpose_code',
                label: `Purpose`,
              },
              purposeOptions
            )}
          </div>
          {isCountryCodeRequired ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createSelectCountry({
                required: true,
                key: 'purpose_country_code',
                label: `Purpose Specify Country`,
              })}
            </div>
          ) : (
            <></>
          )}
          {_.get(formData, 'purpose_code') === 'OTHER' ? (
            <div className="col-sm-12 col-md-6 form-group">
              {createInput({
                required: true,
                key: 'purpose_specify',
                label: `Purpose Specify`,
              })}
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createInputDate: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  createInputMobileNumber: PropTypes.instanceOf(Function).isRequired,
  createSelectAddress: PropTypes.instanceOf(Function).isRequired,
  createInputMask: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
  getPurposeList: PropTypes.instanceOf(Function).isRequired,
  purposeList: PropTypes.instanceOf(Array).isRequired,
  createSelectCountry: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_MARRIAGE) > -1,
  purposeList: _.get(api, `${c.GET_PURPOSE_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
